import { render, staticRenderFns } from "./KfActionPanel.vue?vue&type=template&id=5b97fd7e&scoped=true"
import script from "./KfActionPanel.vue?vue&type=script&lang=js"
export * from "./KfActionPanel.vue?vue&type=script&lang=js"
import style0 from "./KfActionPanel.vue?vue&type=style&index=0&id=5b97fd7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b97fd7e",
  null
  
)

export default component.exports